import React, { FC } from 'react';

export const RadioGroup: FC<{
	radioObject: any;
	label?: string;
	componentId?: string;
}> = (props) => {
	return (
		<div className="vtex-radioGroup" data-selection={props?.componentId}>
			<fieldset className="vtex-radioGroup__fieldset vtex-input w-100 bn pa0 m0">
				<legend className="vtex-radioGroup__legend dt" style={{ padding: '0.01em 0px 0px;' }}>
					<span className="vtex-radioGroup__label vtex-input__label db mb3 w-100 c-on-base t-small">
						{props.label || 'radio'}
					</span>
				</legend>
				<label
					className="vtex-radioGroup__radioLabel db br3 b--muted-4 pointer"
					style={{ borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px;' }}
				>
					<div className="vtex-radioGroup__radioContainer">
						<div className="vtex-radio flex items-start relative pointer mb3">
							<div className="vtex-radio__fakeRadioContainer">
								<div
									className="vtex-radio__fakeRadio fake-radio relative ba br-100 mr3 flex justify-center items-center b--muted-4 pointer"
									style={{
										borderWidth: '3px',
										height: '1.25rem',
										width: '1.25rem',
										transition: 'border 100ms ease-in-out 0s;',
									}}
								>
									<div
										className="vtex-radio__fakeRadioInner br-100 bg-action-primary"
										style={{
											height: '0.5rem',
											width: '0.5rem',
											transform: 'scale(0)',
											transition: 'transform 80ms ease-in 0s;',
										}}
									></div>
								</div>
							</div>
							<input
								className="vtex-radio__input absolute o-0 pointer"
								id="#/properties/gender-0"
								name="#/properties/gender"
								type="radio"
								value="PF"
								style={{ height: '1.5rem', width: '1.5rem' }}
							/>
							<label className="vtex-radio__label flex flex-auto c-on-base pointer" style={{ wordBreak: 'break-word' }}>
								Pessoa Física
							</label>
						</div>
					</div>
				</label>
				<label
					className="vtex-radioGroup__radioLabel db br3 b--muted-4 pointer"
					style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px', borderTop: 'none;' }}
				>
					<div className="vtex-radioGroup__radioContainer">
						<div className="vtex-radio flex items-start relative pointer">
							<div className="vtex-radio__fakeRadioContainer">
								<div
									className="vtex-radio__fakeRadio fake-radio relative ba br-100 mr3 flex justify-center items-center b--action-primary pointer"
									style={{
										borderWidth: '3px',
										height: '1.25rem',
										width: '1.25rem',
										transition: 'border 100ms ease-in-out',
									}}
								>
									<div
										className="vtex-radio__fakeRadioInner br-100 bg-action-primary"
										style={{
											height: '0.5rem',
											width: '0.5rem',
											transform: 'scale(1)',
											transition: 'transform 80ms ease-out 0s;',
										}}
									></div>
								</div>
							</div>
							<input
								checked={true}
								className="vtex-radio__input absolute o-0 pointer"
								id="#/properties/gender-1"
								name="#/properties/gender"
								type="radio"
								value="PJ"
								style={{ height: '1.5rem', width: '1.5rem;' }}
							/>
							<label className="vtex-radio__label flex flex-auto c-on-base pointer" style={{ wordBreak: 'break-word' }}>
								Pessoa Jurídica
							</label>
						</div>
					</div>
				</label>
			</fieldset>
		</div>
	);
};
